module.exports = "<canvas #myScheduling></canvas>\n"